<template>
  <div class="playphone-login inline-input">
    <h1 v-t.preserve="'auth.playphone.title'" />
    <h2 v-t.preserve="'auth.playphone.subtitle'" />

    <form class="input-container" @submit.prevent="submit" novalidate autocomplete="off">
      <pk-input v-model="email" :placeholder="$t('auth.playphone.placeholder.email')" type="email" :error="errorCode || $v.$error" inline />
      <btn flat :loading="loading" submit>{{ $t('auth.playphone.signIn') }}</btn>
      <div class="info">
        <error-text :active="errorCode || $v.$error" :text="errorCode ? this.$t('auth.playphone.error.generic') : this.$t('auth.playphone.error.email')" />
        <p class="link">
          {{ $t('auth.playphoneLastStep.forgotUserId.message') }}
          <a id="checkout-cadastro-cta-esqueci-id-playphone" href="https://lootgames.co/l/sprint/playkids/pages/recovery.html" target="_blank" v-t.preserve="'auth.playphoneLastStep.forgotUserId.CTA'"/>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { AuthenticationPlatform } from '@/api/peanutbutter'
import authenticationService from '@/js/AuthenticationService'
import formSubmit from '@/js/mixins/formSubmit'

export default {
  name: 'playphone-login',
  mixins: [formSubmit('login')],
  data: () => ({
    email: ''
  }),
  validations: {
    email: { required, email }
  },
  methods: {
    async login() {
      await authenticationService.signIn({
        authenticationError: this.$t('auth.playphone.error'),
        signInParameters: {
          authenticationPlatform: AuthenticationPlatform.PLAYPHONE,
          credentials: { email: this.email }
        }
      })

      this.$emit('authenticated')
    }
  }
}
</script>
